var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconError = function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.118 1.404a1 1 0 0 1 1.764 0l8.334 15.625a1 1 0 0 1-.883 1.471H1.667a1 1 0 0 1-.883-1.47L9.118 1.403ZM9.062 7.25a.937.937 0 1 1 1.876 0v3.125a.937.937 0 1 1-1.876 0V7.25Zm2.188 7.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
  })));
};
export default SvgIconError;